import React, { useEffect, useState } from "react";
import { loadServices } from "../services/contentSource";
import { Link } from "react-router-dom";
import { toSlug } from "../utils/slug";
import serviceAreaFallback from "../data/home/serviceAreaData.json";

const ServiceArea: React.FC = () => {
  const [data, setData] = useState<any>(serviceAreaFallback);

  useEffect(() => {
    loadServices().then((res) => {
      if (res) setData(res);
    });
  }, []);

  if (!data) return null;

  const rawTitle = data.header?.title || data.section?.title || "PREMIUM AI SERVICES CRAFTED BY MINDSYNCX";
  const headerTitle = rawTitle.replace(/<[^>]*>/g, " ");
  const headerSubtitle =
    data.header?.subtitle ||
    data.section?.text ||
    "Fusion of deep engineering expertise and a systems-first mindset — how we build faster, solve smarter, and run with zero downtime.";
  const services = (data.services || []).filter((s: any) => !s.isDeleted);

  return (
    <section className="service-area mx-services-revamp" id="service-catalog">
      <div className="container mx-container">
        <div className="mx-services-header">
          <div className="mx-hero-badge">
            <span className="mx-hero-badge-icon">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                <rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect>
                <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
              </svg>
            </span>
            <span>02. CORE ARCHITECTURE &amp; CAPABILITIES</span>
          </div>

          <h2 className="mx-services-title">
            {headerTitle}
          </h2>

          <p className="mx-services-lede">
            {headerSubtitle}
          </p>
        </div>

        <div className="mx-services-grid">
          {services.map((service: any, index: number) => {
            const cleanTitle = (service.title || "").replace(/<br\s*\/?>/gi, " ");
            const padIndex = String(service.number || `${index + 1}.`).replace(".", "");
            const formattedNum = padIndex.padStart(2, "0");
            const slug = toSlug(service.title, service.id);

            return (
              <div className="mx-service-card" key={service.id || index}>
                <div className="mx-service-card-top">
                  <span className="mx-service-card-num">{formattedNum}</span>
                  <div className="mx-service-card-icon">
                    <img
                      className="show-light"
                      src={service.icon?.light || "/assets/imgs/icon/icon-s-36.webp"}
                      alt="service icon"
                      loading="lazy"
                      decoding="async"
                    />
                    <img
                      className="show-dark"
                      src={service.icon?.dark || "/assets/imgs/icon/icon-s-36-light.webp"}
                      alt="service icon"
                      loading="lazy"
                      decoding="async"
                    />
                  </div>
                </div>

                <div className="mx-service-card-body">
                  <h3 className="mx-service-card-title">{cleanTitle}</h3>
                  <p className="mx-service-card-desc">
                    {service.description || "Production-tested AI architecture engineered for enterprise reliability."}
                  </p>

                  <div className="mx-service-features-list">
                    {(service.features || []).map((feature: string, idx: number) => (
                      <div className="mx-service-feature-item" key={idx}>
                        <svg
                          className="mx-service-feature-check"
                          width="14"
                          height="14"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <polyline points="20 6 9 17 4 12"></polyline>
                        </svg>
                        <span>{feature}</span>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="mx-service-card-footer">
                  <Link
                    to={service.link || `/services/${slug}`}
                    className="mx-service-card-link"
                  >
                    <span>Explore Architecture</span>
                    <svg
                      width="15"
                      height="15"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <line x1="5" y1="12" x2="19" y2="12"></line>
                      <polyline points="12 5 19 12 12 19"></polyline>
                    </svg>
                  </Link>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServiceArea;
